import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 13,
	viewBox: "0 0 6 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.479871 12.41C0.261603 12.2408 0.221792 11.9267 0.390949 11.7085L4.58215 6.30046L0.390949 0.892461C0.221792 0.674193 0.261604 0.360125 0.479871 0.190968C0.698138 0.0218105 1.01221 0.0616217 1.18136 0.279889L5.60994 5.99418C5.74966 6.17446 5.74966 6.42646 5.60994 6.60675L1.18136 12.321C1.01221 12.5393 0.698138 12.5791 0.479871 12.41Z",
		fill: "#212121"
	})
});
export default SvgCaretRightIcon;
